import { configs } from '@constants/configs/configs';
import type { STATES_TYPE } from '@constants/configs/states';

type HomePageRoutes = {
    [key in STATES_TYPE]?:
        | string
        | {
              disclaimer: string;
              prescreener: string;
          };
};

const HOME_PAGE: HomePageRoutes = {
    GA: configs.routes.PRE_SCREENER,
    ID: configs.routes.PRE_SCREENER,
    MN: {
        disclaimer: configs.routes.PRE_SCREENER,
        prescreener: configs.routes.PRE_SCREENER,
    },
    NV: configs.routes.PRE_SCREENER,
    NJ: configs.routes.PRE_SCREENER,
    PA: configs.routes.PRE_SCREENER,
    VA: configs.routes.PRE_SCREENER,
};
export const getRouteAndState = (
    leadPresent: string | null,
    storedDisclaimerVal: string | null,
    stateCode: STATES_TYPE,
): { route: string; disclaimerState: boolean } => {
    let disclaimerState = true;
    let route = configs.routes.PRE_SCREENER;
    const homePageRoute = HOME_PAGE[stateCode];
    disclaimerState = false;
    route = typeof homePageRoute === 'string' ? homePageRoute : configs.routes.PRE_SCREENER;
    /* Uncomment for later release
    if (['MN'].includes(stateCode) && leadPresent === null) {
        const homePageRoute = HOME_PAGE[stateCode];
        if (typeof homePageRoute === 'object' && homePageRoute !== null && DISCLAIMER in homePageRoute && PRESCREENER in homePageRoute) {
            if (storedDisclaimerVal === null) {
                disclaimerState = true;
                route = homePageRoute.disclaimer;
            } else {
                disclaimerState = false;
                route = homePageRoute.prescreener;
            }
        }
    } else {
      const homePageRoute = HOME_PAGE[stateCode];
      disclaimerState = false;
    }

     */
    return { route, disclaimerState };
};

export interface IRenderConsumerSignUpEnabledProps {
    path: string;
    exchangeName: string;
    isState: Record<string, boolean>;
    currentYear: string;
    landingPageAnonymousTileShow: boolean;
}
export interface IRenderConsumerSignUpNotEnabledProps {
    currentYear: string;
}
export interface IHomeProps {
    environment: {
        exchangeName: string;
        isState: Record<string, boolean>;
        consumerSignupEnabled: boolean;
        landingPageAnonymousTileShow: boolean;
    };
    path: string;
}
